import React from 'react';

export const DiscountSignalIcon: React.FC = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.33464 13.3335L2.66797 8.66683L8.0013 3.3335H12.0013C12.3695 3.3335 12.668 3.63197 12.668 4.00016V8.00016L7.33464 13.3335ZM10.6678 6.16683C11.128 6.16683 11.5011 5.79373 11.5011 5.3335C11.5011 4.87326 11.128 4.50016 10.6678 4.50016C10.2076 4.50016 9.83447 4.87326 9.83447 5.3335C9.83447 5.79373 10.2076 6.16683 10.6678 6.16683Z"
      fill="#261B36"
    />
  </svg>
);
